const SectionWithBackground = ({ background, children, applyClass = "" }) => (
  <div
    style={{
      backgroundImage: `url(${background})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      margin: 0,
      // textAlign: "center",
    }}
    className={applyClass}
  >
    {children}
  </div>
);
export default SectionWithBackground;